import {
  $create, $put, $patch, $post, $delete, $upload, $download, $get,
} from '~/api/client';

export function selectMission(missionId) {
  return $put(`/v2/missions/${missionId}/select`);
}

export function unselectMission(missionId) {
  return $put(`/v2/missions/${missionId}/unselect`);
}

export function assignMission(missionId) {
  return $put(`/v2/missions/${missionId}/assign`);
}

export function patch({ id, attributes, relationships = undefined }, { config = {} } = {}) {
  return $patch(`missions/${id}`, {
    id,
    type: 'mission',
    attributes,
    relationships,
  }, config);
}

// @feat: Hide OSC number
export function event({ id, attributes }, { config = {} } = {}) {
  return $post(`/v2/missions/${id}/events`, {
    data: {
      id,
      type: 'mission_event',
      attributes,
    },
  }, config);
}

export function deleteBlocker({ missionId, blockerId }, { config = {} } = {}) {
  return $delete(`missions/${missionId}/blockers/${blockerId}`, false, config);
}

export function createEvent(missionId, event_code, payload = undefined) {
  return $create(`missions/${missionId}/events`, {
    type: 'mission_event',
    attributes: {
      code: event_code,
      payload,
    },
  });
}

export function updateMissionAppointment(missionId, approved_appointment, { config = {} } = {}) {
  return $patch(
    `missions/${missionId}/appointment`,
    {
      type: 'mission',
      id: missionId,
      attributes: {
        approved_appointment,
      },
    },
    config,
  );
}

export function uploadDocument({ missionId, files }, { config = {} } = {}) {
  const formData = new FormData();
  files.forEach((file, index) => {
    formData.append(`data[${index}][type]`, 'mission');
    formData.append(`data[${index}][id]`, missionId);
    formData.append(`data[${index}][attributes][document]`, file);
  });

  return $upload(
    `missions/${missionId}/documents/attach`,
    formData,
    config,
  );
}

export function deleteDocument({ missionId, documentId }, { config = {} } = {}) {
  return $delete(`missions/${missionId}/documents/${documentId}`, false, config);
}

export function updateMissionAddress(missionId, { id, attributes }, { config = {} } = {}) {
  return $patch(
    `missions/${missionId}/address`,
    {
      id,
      attributes,
    },
    config,
  );
}

export function downloadAppointmentCalendar(
  { missionId, format, missionDate },
  { config = {} } = {},
) {
  return $download(
    `/v2/missions/${missionId}/appointment/download/${format}`,
    config,
    { baseName: `ocus-calendar-${missionDate}.ics` },
  );
}

export function fetchQcRateDetails(missionId, { config = {} } = {}) {
  return $get(
    `image-creators/missions/${missionId}/rates/qc`,
    config,
  );
}
